// import React, { useEffect, useState } from "react";
// import { Spinner, Card, Row, Col, Button, Table } from "react-bootstrap";
// import { useParams } from "react-router-dom";
// import GuestDetailsCard from "./components/GuestDetailsCard";
// import ReservationRoomsTable from "./components/ReservationRoomsTable";
// import FolioChargesCard from "./components/FolioChargesCard";
// import AuditTrailCard from "./components/AuditTrailCard";
// import api from "../../../api/axios";

// export default function EditReservation() {
//   const { reservationId } = useParams();
//   const [loading, setLoading] = useState(true);
//   const [reservation, setReservation] = useState(null);
//   const [audits, setAudits] = useState([]);

//   useEffect(() => {
//     fetchReservation();
//   }, [reservationId]);

//   const fetchReservation = async () => {
//     try {
//       const res = await api.get(`/pms/reservations/${reservationId}`);
//       setReservation(res.data.data.reservation);
//       setAudits(res.data.data.audits);
//     } catch (err) {
//       console.error("Failed to load reservation", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading)
//     return (
//       <div className="text-center py-5">
//         <Spinner animation="border" />
//       </div>
//     );

//   if (!reservation)
//     return (
//       <div className="text-center text-muted py-5">Reservation not found.</div>
//     );

//   return (
//     <div className="container-fluid py-3">
//       <div className="d-flex justify-content-between align-items-center mb-3">
//         <h4 className="fw-bold">
//           Edit Reservation #{reservation.reservation_number}
//         </h4>
//         <div className="d-flex gap-2">
//           <Button variant="primary" onClick={fetchReservation}>
//             Refresh
//           </Button>
//           <Button variant="success">Check In</Button>
//           <Button variant="danger">Cancel</Button>
//         </div>
//       </div>

//       {/* Guest Details */}
//       <GuestDetailsCard guest={reservation.guest} reservation={reservation} />

//       {/* Room Info */}
//       <Card className="mb-3 border-0 shadow-sm">
//         <Card.Header className="fw-semibold bg-light">Rooms</Card.Header>
//         <Card.Body>
//           <ReservationRoomsTable rooms={reservation.rooms} />
//         </Card.Body>
//       </Card>

//       {/* Folio */}
//       {reservation.folio && <FolioChargesCard folio={reservation.folio} />}

//       {/* Audit Trail */}
//       <AuditTrailCard audits={audits} />
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import api from "../../../api/axios"; // Adjust based on your folder structure
import { useParams } from "react-router-dom";

export default function EditReservationPage() {
  const { reservationId } = useParams();
  const [activeTab, setActiveTab] = useState("folioOps");
  const [reservation, setReservation] = useState(null);
  const [audits, setAudits] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchReservation();
  }, [reservationId]);

  const fetchReservation = async () => {
    try {
      const res = await api.get(`/pms/reservations/${reservationId}`);
      setReservation(res.data.data.reservation);
      setAudits(res.data.data.audits);
    } catch (error) {
      console.error("Error fetching reservation:", error);
    } finally {
      setLoading(false);
    }
  };

  const renderTab = () => {
    switch (activeTab) {
      case "folioOps":
        return <FolioOperations folio={reservation?.folio} />;
      case "roomCharges":
        return <RoomCharges rooms={reservation?.rooms || []} />;
      case "guestDetails":
        return <GuestDetails guest={reservation?.guest} />;
      case "bookingDetails":
        return <BookingDetails reservation={reservation} />;
      //   case "creditCard":
      //     return <CreditCard />;
      case "auditTrail":
        return <AuditTrail audits={audits} />;
      default:
        return null;
    }
  };

  if (loading)
    return (
      <div className="text-center py-5">
        <div className="spinner-border" role="status" />
      </div>
    );

  if (!reservation)
    return <div className="text-center text-muted">No reservation found.</div>;

  const nights = Math.max(
    1,
    (new Date(reservation.check_out) - new Date(reservation.check_in)) /
      (1000 * 60 * 60 * 24)
  );

  return (
    <div className="container-fluid mt-3">
      {/* Header */}
      <div className="card shadow-sm border-0 mb-3">
        <div className="card-body d-flex flex-wrap justify-content-between align-items-center">
          <div>
            <h4 className="fw-bold mb-1">{reservation.guest?.name}</h4>
            <div className="text-muted small">
              👤 {reservation.rooms?.[0]?.adults ?? 1} Adults,{" "}
              {reservation.rooms?.[0]?.children ?? 0} Child
            </div>
          </div>
          <div className="text-end">
            <div className="fw-semibold">
              Arrival:{" "}
              <span className="text-dark">
                {new Date(reservation.check_in).toLocaleString()}
              </span>{" "}
              <span className="mx-2">|</span> Departure:{" "}
              <span className="text-dark">
                {new Date(reservation.check_out).toLocaleString()}
              </span>
            </div>
            <div className="small text-muted">
              Nights: {nights} • Room{" "}
              {reservation.rooms?.[0]?.room?.room_number} /{" "}
              {reservation.rooms?.[0]?.room?.room_type_name}
            </div>
            <div className="mt-2">
              <span className="badge bg-success">Confirmed</span>
            </div>
          </div>
        </div>
      </div>

      {/* Top Buttons */}
      <div className="d-flex flex-wrap gap-2 mb-3">
        <button className="btn btn-primary btn-sm">💾 Save Changes</button>
        <button className="btn btn-success btn-sm">✅ Check In</button>
        <button className="btn btn-outline-secondary btn-sm">
          🧾 Print Confirmation
        </button>
        <button className="btn btn-outline-danger btn-sm">
          ❌ Cancel Reservation
        </button>
      </div>

      {/* Tabs */}
      <ul className="nav nav-tabs">
        {[
          ["folioOps", "Folio Operations"],
          ["roomCharges", "Room Charges"],
          ["guestDetails", "Guest Details"],
          ["bookingDetails", "Booking Details"],
          //   ["creditCard", "Credit Card"],
          ["auditTrail", "Audit Trail"],
        ].map(([key, label]) => (
          <li className="nav-item" key={key}>
            <button
              className={`nav-link ${activeTab === key ? "active" : ""}`}
              onClick={() => setActiveTab(key)}
            >
              {label}
            </button>
          </li>
        ))}
      </ul>

      <div className="tab-content mt-3">{renderTab()}</div>
    </div>
  );
}

/* ------------------------------------------------------------------
   🧾 Folio Operations Tab
------------------------------------------------------------------ */
function FolioOperations({ folio }) {
  if (!folio) return <div className="text-muted">No folio found.</div>;
  return (
    <div className="row">
      <div className="col-md-3 border-end">
        <div className="fw-semibold text-muted mb-2">Folio</div>
        <ul className="list-group">
          <li className="list-group-item active">
            {folio.folio_number || "Folio"}
          </li>
        </ul>
      </div>

      {/* Charges */}
      <div className="col-md-9">
        <div className="d-flex justify-content-between mb-3">
          <div className="fw-semibold text-muted">Folio Transactions</div>
          <div className="d-flex flex-wrap gap-2">
            <button className="btn btn-outline-primary btn-sm">
              Add Payment
            </button>
            <button className="btn btn-outline-primary btn-sm">
              Add Charges
            </button>
            <button className="btn btn-outline-success btn-sm">
              Print Invoice
            </button>
          </div>
        </div>

        <div className="table-responsive border rounded">
          <table className="table table-hover align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th>Date</th>
                <th>Description</th>
                <th>Type</th>
                <th className="text-end">Amount</th>
              </tr>
            </thead>
            <tbody>
              {folio.charges?.length > 0 ? (
                folio.charges.map((c, i) => (
                  <tr key={i}>
                    <td>{new Date(c.date).toLocaleDateString()}</td>
                    <td>{c.description}</td>
                    <td>{c.charge_type}</td>
                    <td className="text-end">
                      ₹ {Number(c.amount).toFixed(2)}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center text-muted py-3">
                    No charges found.
                  </td>
                </tr>
              )}
            </tbody>
            <tfoot className="table-light">
              <tr>
                <td colSpan="3" className="text-end fw-bold">
                  Balance
                </td>
                <td className="text-end fw-bold text-danger">
                  ₹ {Number(folio.balance || 0).toFixed(2)}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
}

/* ------------------------------------------------------------------
   🏨 Room Charges Tab
------------------------------------------------------------------ */
function RoomCharges({ rooms }) {
  if (!rooms.length) return <div className="text-muted">No rooms found.</div>;
  return (
    <div className="card border-0 shadow-sm">
      <div className="card-body">
        <h6 className="fw-bold mb-3">Room Charges Summary</h6>
        <table className="table table-hover align-middle mb-0">
          <thead className="table-light">
            <tr>
              <th>Room No</th>
              <th>Room Type</th>
              <th>Rate Type</th>
              <th className="text-end">Rate</th>
              <th className="text-end">Tax</th>
              <th className="text-end">Total</th>
            </tr>
          </thead>
          <tbody>
            {rooms.map((r, i) => (
              <tr key={i}>
                <td>{r.room?.room_number}</td>
                <td>{r.room?.room_type_name}</td>
                <td>{r.rate_type?.name}</td>
                <td className="text-end">₹ {Number(r.rate || 0).toFixed(2)}</td>
                <td className="text-end">
                  ₹ {Number(r.tax_amount || 0).toFixed(2)}
                </td>
                <td className="text-end">
                  ₹ {Number(r.total || 0).toFixed(2)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

/* ------------------------------------------------------------------
   👤 Guest Details Tab
------------------------------------------------------------------ */
function GuestDetails({ guest }) {
  if (!guest) return <div className="text-muted">No guest found.</div>;
  return (
    <div className="card border-0 shadow-sm">
      <div className="card-body">
        <h6 className="fw-bold mb-3">Guest Information</h6>
        <div className="row g-3">
          <div className="col-md-3">
            <label className="form-label">Title</label>
            <input
              type="text"
              className="form-control"
              defaultValue={guest.title || ""}
            />
          </div>
          <div className="col-md-3">
            <label className="form-label">Name</label>
            <input
              type="text"
              className="form-control"
              defaultValue={guest.name || ""}
            />
          </div>
          <div className="col-md-3">
            <label className="form-label">Mobile</label>
            <input
              type="text"
              className="form-control"
              defaultValue={guest.mobile_no || ""}
            />
          </div>
          <div className="col-md-3">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-control"
              defaultValue={guest.email || ""}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

/* ------------------------------------------------------------------
   📋 Booking Details Tab
------------------------------------------------------------------ */
function BookingDetails({ reservation }) {
  return (
    <div className="card border-0 shadow-sm">
      <div className="card-body">
        <h6 className="fw-bold mb-3">Booking Details</h6>
        <div className="row g-3">
          <div className="col-md-4">
            <label className="form-label">Source of Booking</label>
            <input
              type="text"
              className="form-control"
              defaultValue={reservation?.source_of_booking || ""}
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Reference No</label>
            <input
              type="text"
              className="form-control"
              defaultValue={reservation?.booking_reference_no || ""}
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Remarks</label>
            <input
              type="text"
              className="form-control"
              defaultValue={reservation?.remarks || ""}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

/* ------------------------------------------------------------------
   🔍 Audit Trail Tab
------------------------------------------------------------------ */
function AuditTrail({ audits }) {
  if (!audits.length) return <div className="text-muted">No audit logs.</div>;
  return (
    <div className="card border-0 shadow-sm">
      <div className="card-body">
        <h6 className="fw-bold mb-3">Audit Trail</h6>
        <table className="table table-hover align-middle">
          <thead className="table-light">
            <tr>
              <th>Date</th>
              <th>User</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {audits.map((a, i) => (
              <tr key={i}>
                <td>{new Date(a.created_at).toLocaleString()}</td>
                <td>{a.user_id || "-"}</td>
                <td>{a.action}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
